var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealityCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10a9.957 9.957 0 01-2.42 6.518l1.95 1.952.052.056a.75.75 0 01-1.056 1.056l-.056-.052-1.951-1.951A9.957 9.957 0 0112 21.999a9.958 9.958 0 01-6.52-2.42L3.53 21.53a.75.75 0 01-1.06-1.06l1.95-1.952A9.958 9.958 0 012 12C2 6.477 6.477 2 12 2zm4.751 6a.756.756 0 00-.555.228l-5.413 5.414-2.445-2.446a.765.765 0 00-.55-.223.746.746 0 00-.56.223.756.756 0 00-.228.555c0 .217.076.402.229.555l2.888 2.888c.19.19.413.285.666.285a.914.914 0 00.666-.285l5.857-5.856a.765.765 0 00.223-.55.745.745 0 00-.223-.56A.756.756 0 0016.75 8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.526 1.418a.75.75 0 011.056 1.056l-.052.056-2 2a.75.75 0 11-1.06-1.06l2-2 .056-.052zM19.47 1.47a.75.75 0 011.004-.052l.056.052 2 2 .052.056a.75.75 0 01-1.056 1.056l-.056-.052-2-2-.052-.056a.75.75 0 01.052-1.004z",
    fill: "currentColor"
  })));
}
SvgRealityCheckFilled.displayName = 'RealityCheckFilled';
export default SvgRealityCheckFilled;